<div class="modal-docs-content unsuccess-request-modal modal-body failure-modal no-margin-top pt-0 mb-2 pb-4">
    <div class="modal-block margin-top mt16 text-center">
        <div>
            <img src="./assets/img/images/icon-warning.svg" alt="expired icon" />
        </div>
        <div class="bigger-font-size margin-top mt16">
            <div> {{ 'TRY_AGAIN_LATER' | translate }} </div>
        </div>
        <div class="margin-top mt16 col-2d373d fs-16" [ngClass]="{'lh-normal' : isAcmic}">
            {{ "PROBLEM_WITH_SUBMISSION" | translate }}
        </div>
    </div>

    <div class=" contact-assistance margin-top mt32 text-center" [ngClass]="{'contact-info-container': !isAcmic}">
        <ng-container *ngIf="isAcmic; else maAssistance;">
            <div class="font-weight-500 fs-16">
                {{ "If you need immediate assistance, please contact us:" | translate }}
            </div>
            <div class="mt-4 font-weight-500 contact-media fs-16">
                Email: <a href="mailto:eccservicecenter&#64;Insure.WA.AAA.com"
                    class="underlineBQ">eccservicecenter&#64;Insure.WA.AAA.com</a>
            </div>
            <div class="mt-4 font-weight-500 contact-media fs-16">
                Phone: <a href="tel:844-295-4500" class="underlineBQ">844-295-4500</a>
            </div>
            <div class="contact-schedule mt-4 mb5">
                {{ 'Monday to Friday 8 am - 6 pm PST' | translate }}
            </div>
            <div class="contact-schedule">{{ 'Saturdays 6 am - 12 pm PST' | translate }}</div>
        </ng-container>
        <ng-template #maAssistance>
            <div class="font-weight-500">
                {{ "IF_NEED_IMMEDIATE_ASSISTANCE" | translate }}
                <a routerLink='/contact' class="see-dec nobr">{{ "contact us here" }}</a>, or call:
            </div>

            <div class="mt-4 font-weight-500">
                Phone: <a href="tel:18556273737" class="mapfre link underline red-link">1-855-627-3737</a>
            </div>
            <div class="contact-schedule mt-4 mb5">
                {{ 'MONDAY_FRIDAY_EST' | translate }}
            </div>
            <div class="contact-schedule">{{ 'SATURDAY_EST' | translate }}</div>
        </ng-template>

    </div>

    <hr class="ma-hr-tag margin-top mt32 mb-2" />

    <div class="row text-right pt-4">
        <div class="col show-btn-order pl-0" [ngClass]="{'ml-0':isAcmic}">
            <mapfre-button [additionalClasses]="'ghost secondary small-btn modal-small-btn no-border mr-0 mt-0'"
                [iconClasses]="'align-middle'" (click)="tryAgain(false)">
                {{ 'Go to documents' }}
            </mapfre-button>
            <mapfre-button [additionalClasses]="'basic primary small-btn modal-small-btn'" [ngClass]="{'ml-3': isAcmic}"
                (click)="tryAgain(true)">
                {{ 'TRY_AGAIN' | translate }}</mapfre-button>
        </div>
    </div>
</div>